<template>
  <v-card style="padding-top:15px;padding-bottom:15px">
    <v-layout wrap>
      <v-flex v-for="(a,i) in analysis" :key="i" md3 class="pa-3">
        <fs1-span>
          <b>{{a.label}} </b>
          <span>{{a.value}}</span>
        </fs1-span>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
export default {
  props: ['analysis'],
};
</script>
